export default {
  'general-ledger': 'GENERAL_LEDGER',
  'pawns': 'PAWNS',
  'layaways': 'LAYAWAY',
  'customers': 'CUSTOMERS',
  'other': 'OTHER',
  'forex': 'FOREX',
  'regulatory': 'REGULATORY',
  'stocked-report': 'STOCKED_ITEMS'
}
